@defer (hydrate on immediate) {
	<div class="flex flex-col gap-10 pt-28">
		<div class="flex flex-col md:flex-row justify-around items-center gap-4">
			<peps-title
				[subtitle]="'page.galleries.subtitle' | translate"
				[title]="'page.galleries.title-on-page' | translate"
			></peps-title>
			<span class="invisible sm:visible"></span>
		</div>
		<div class="flex flex-row flex-wrap gap-x-12 gap-y-10 justify-center items-center">
			@if(galleries.length > 0) {
				@for (gallery of galleries; track gallery.id) {
					<peps-gallery-card
						[gallery]="gallery"
					></peps-gallery-card>
				}
			} @else {
				<peps-no-content
					[text]="'component.no-gallery.text' | translate"
				></peps-no-content>
			}
		</div>

		@if(totalPages > 1) {
			<peps-page-selector
				[page]="page"
				[totalPages]="totalPages"
				(pageChange)="onPageChange($event)"
			></peps-page-selector>
		}
		<peps-last-videos></peps-last-videos>
	</div>
}
